const english = {
    'STAFF_MANAGEMENT.Title_Point': "Check-in point",
    'STAFF_MANAGEMENT.Title_Attendance': "Attendance",
    'STAFF_MANAGEMENT.UseLocation': "Use my location",
    'STAFF_MANAGEMENT.SetPoint': "Set the check-in point",
    'STAFF_MANAGEMENT.SetPointHelp': "Stand at the spot where workers check in, then save your location.",
    'STAFF_MANAGEMENT.CheckPin': "Check this is the right spot",
    'STAFF_MANAGEMENT.CheckSpot': "Check the pin then save",
    'STAFF_MANAGEMENT.Retake': "Retake",
    'STAFF_MANAGEMENT.Save': "Save",
    'STAFF_MANAGEMENT.Saving': "Saving…",
    'STAFF_MANAGEMENT.Locating': "Refining your location. Stay at the check-in spot — this can take up to 15 seconds.",
    'STAFF_MANAGEMENT.LocationAccuracy': "Estimated accuracy: { accuracy } m",
    'STAFF_MANAGEMENT.LowAccuracyTitle': "Low location accuracy",
    'STAFF_MANAGEMENT.LowAccuracyHelp': "Check the pin and move it if needed.",
    'STAFF_MANAGEMENT.LocationPermission': "Allow location access in your browser settings, then try again.",
    'STAFF_MANAGEMENT.LocationTimeout': "Could not determine your location in time. Stay at the check-in spot and try again.",
    'STAFF_MANAGEMENT.LocationUnavailable': "Your location is unavailable. Check your device’s location settings and try again.",
    'STAFF_MANAGEMENT.MapUnavailable': "The map could not be loaded. Try again.",
    'STAFF_MANAGEMENT.Ready': "Ready for check-in",
    'STAFF_MANAGEMENT.UpdateLocation': "Update location",
    'STAFF_MANAGEMENT.ViewQr': "View QR code",
    'STAFF_MANAGEMENT.PointCreated': "Check-in point set",
    'STAFF_MANAGEMENT.PointUpdated': "Check-in point updated",
    'STAFF_MANAGEMENT.SaveError': "Could not confirm the save. Check your connection and try again.",
    'STAFF_MANAGEMENT.NoManageAccess': "You do not have permission to set or change this check-in point.",
    'STAFF_MANAGEMENT.NoAttendanceAccess': "You do not have permission to view staff attendance.",
    'STAFF_MANAGEMENT.SelectExhibition': "Select an exhibition first.",
    'STAFF_MANAGEMENT.Loading': "Loading…",
    'STAFF_MANAGEMENT.Retry': "Try again",
    'STAFF_MANAGEMENT.Back': "Back",
    'STAFF_MANAGEMENT.QrTitle': "Check-in QR code",
    'STAFF_MANAGEMENT.QrMissing': "A check-in QR code is not available yet.",
    'STAFF_MANAGEMENT.QrError': "Could not load the QR code. Try again.",
    'STAFF_MANAGEMENT.GenerateQr': "Create QR code",
    'STAFF_MANAGEMENT.GeneratingQr': "Creating QR code…",
    'STAFF_MANAGEMENT.QrGenerateError': "The point is saved, but the QR code could not be created. Try again.",
    'STAFF_MANAGEMENT.DownloadPdf': "Download PDF",
    'STAFF_MANAGEMENT.PdfLoading': "Preparing PDF…",
    'STAFF_MANAGEMENT.PdfError': "Could not create the PDF. Try again.",
    'STAFF_MANAGEMENT.Today': "Today",
    'STAFF_MANAGEMENT.ChooseDate': "Choose date",
    'STAFF_MANAGEMENT.ChooseCompany': "Choose company",
    'STAFF_MANAGEMENT.AllCompanies': "All companies",
    'STAFF_MANAGEMENT.Apply': "Apply",
    'STAFF_MANAGEMENT.NoCheckIn': "No check-in",
    'STAFF_MANAGEMENT.In': "In",
    'STAFF_MANAGEMENT.Out': "Out",
    'STAFF_MANAGEMENT.Working': "Working",
    'STAFF_MANAGEMENT.Completed': "Completed",
    'STAFF_MANAGEMENT.FailedCheckout': "Check-out failed",
    'STAFF_MANAGEMENT.MissedCheckout': "Missed check-out",
    'STAFF_MANAGEMENT.UnknownStatus': "Unknown status",
    'STAFF_MANAGEMENT.NoAttendanceRecords': "No attendance records for this date.",
    'STAFF_MANAGEMENT.NoMatches': "No workers match the selected filters.",
    'STAFF_MANAGEMENT.AttendanceError': "Could not load attendance. Try again.",
    'STAFF_MANAGEMENT.UnknownCompany': "Company not specified",
    'STAFF_MANAGEMENT.LoadPointError': "Could not load the check-in point. Try again.",
    'STAFF_MANAGEMENT.PosterTitle': "Check-in / Check-out",
    'STAFF_MANAGEMENT.PosterInstructions': "Open the ELFE app and scan this QR code when you start and finish work.",
    'STAFF_MANAGEMENT.PosterGenerated': "QR code generated: { date }",
    'PHOTO_SOURCE.TakePhoto' : 'Take photo',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Choose from gallery',
    'CRAFT.Type_Logistics' : 'Logistics { number }',
    'CRAFT.Type_Floor' : 'Floor { number }',
    'CRAFT.Type_Assembly' : 'Assembly { number }',
    'CRAFT.Type_Electrics' : 'Electrics { number }',
    'CRAFT.Type_Graphic' : 'Graphic { number }',
    'CRAFT.Type_Furniture' : 'Furniture { number }',
    'CRAFT.Type_Multimedia' : 'Multimedia { number }',
    'CRAFT.Type_Cleaning' : 'Cleaning { number }',
    'CRAFT.Type_Additional' : 'Additional { number }',
    'CRAFT.Type_MPControl' : 'MP Control',
    'CRAFT.Type_Protocol' : 'Protocol',
    'CRAFT.Type_Service' : 'Service { number }',
    'CRAFT.Type_CollectGraphics' : 'Collect Graphics',
    'CRAFT.Status_Text_InProgress' : 'In progress',
    'CRAFT.Status_Text_Disabled' : 'Disabled',
    'CRAFT.Status_Text_Completed' : 'Completed',
    'CRAFT.Status_Text_Overdue' : 'Overdue',
    'CRAFT.Status_Text_Done' : 'Collected',
    'CRAFT.Status_Text_Open' : 'Open',
    'CRAFT.Status_Text_Collected': 'Collected',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Cannot change status: the graphic has already been processed in the admin panel',
    'CRAFT.Button_ViewAll' : 'View all',
    'CRAFT.Button_Text_Print' : 'Print',
    'CRAFT.Button_Text_Stand' : 'Stand',
    'CRAFT.Button_Text_MarkOpen' : 'Mark craft open',
    'CRAFT.Button_Text_MarkDone' : 'Mark craft done',
    'CRAFT.Button_Text_MarkInProgress' : 'Mark craft in progress',
    'CRAFT.Button_ChangeStatus_InProgress' : 'In progress',
    'CRAFT.Button_ChangeStatus_Done': 'Done',
    'CRAFT.Button_Text_ShelfNumber' : 'Shelf No.',
    'CRAFT.Filter_Params_CraftType' : 'Craft: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Please select an exhibition { br } from the list below',
    'EXHIBITION.Select_Label' : 'CHOSEN EXHIBITION',
    'EXHIBITION.Modal_Title' : 'CHOOSE EXHIBITION',
    'EXHIBITION.Timer_State_Underway' : 'UNDERWAY',
    'EXHIBITION.Timer_State_Ended' : 'ENDED',
    'EXHIBITION.Title_CraftTotal' : 'Total crafts overview',
    'EXHIBITION.Statistic_Status_InTotal' : 'in total',
    'EXHIBITION.Statistic_Status_InProgress' : 'in progress',
    'EXHIBITION.Statistic_Status_Done' : 'done',
    'EXHIBITION.Statistic_Status_Overdue' : 'overdue',
    'EXHIBITION.Statistic_Status_NotApproved' : 'not approved',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'booked for exhibition',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Checked In',
    'EXHIBITION.Statistic_Type_Stands' : 'Stands',
    'EXHIBITION.Statistic_Type_Claims' : 'mp Claims',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Exhibitor claims',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Last minute',
    'EXHIBITION.Statistic_Type_MpControl' : 'mp Control',
    'EXHIBITION.Statistic_Type_Damages' : 'Damages',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protocol',
    'EXHIBITION.Statistic_Type_Staff' : 'Staff',
    'FORM.Textarea_Placeholder_JobDescription' : 'Job description*',
    'FORM.Button_Text_AddJob' : 'Add job',
    'FORM.Button_Text_SaveJob' : 'Save job',
    'FORM.Button_AddJobPhoto' : 'Add photo',
    'FORM_RULES.Required_Login' : 'Please input your Login',
    'FORM_RULES.Required_Password' : 'Please input your Password',
    'FORM_RULES.Required_KeyDescription' : 'Please input key description',
    'FORM_RULES.Required_KeyNumber' : 'Please input key number',
    'FORM_RULES.Required_JobDescription' : 'Please add job description',
    'FORM_RULES.Required_Quantity' : 'Please input quantity',
    'FORM_RULES.Min_Quantity' : 'Quantity must be a number not less then one',
    'FORMS.Input_Label_Login' : 'login',
    'FORMS.Input_Label_Password' : 'password',
    'FORMS.Button_Text_Login' : 'Login',
    'FORMS.Input_Label_Description' : 'Description',
    'FORMS.Input_Label_KeyNumber' : 'Key Number',
    'FORMS.Input_Label_Hall' : 'Hall',
    'FORMS.Input_Label_Stands' : 'Stands',
    'FORMS.Button_Text_ApplyFilters' : 'Apply',
    'FORMS.Button_Text_ResetFilters' : 'Reset Filters',
    'FORMS.Select_DefaultValue_All' : 'All',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'With crafts in progress',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'With completed crafts',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'With control crafts in progress',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'With protocol crafts in progress',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'With overdue crafts',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'With additional jobs',
    'FORMS.Button_Text_ApplySort' : 'Apply',
    'FORMS.Input_Label_CraftType' : 'Craft Type',
    'FORMS.Input_Label_JobType'   : 'Type',
    'FORMS.Input_Label_JobFlag'   : 'Flag',
    'FORMS.Input_Label_JobStatus' : 'Status',
    'FORMS.Input_Label_CraftStatus' : 'Craft Status',
    'FORMS.Input_Label_DamageStatus' : 'Damage Status',
    'FORMS.Input_Label_Subcontractor' : 'Subcontractor',
    'FORMS.Input_Label_Comments' : 'Comments',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Open Jobs',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Jobs in progress',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Finished Jobs',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Without flag',
    'FORMS.Select_JobFlag_WithFlag' : 'With flag',
    'FORMS.Input_Label_FurnishingName' : 'Furnishing name',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Quantity',
    'FORMS.Input_Label_Quantity' : 'Quantity',
    'FORMS.Input_Label_CurrentQuantity' : 'Current quantity',
    'FORMS.Input_Label_NewQuantity' : 'New quantity',
    'FORMS.RadioInput_Text_Description' : 'Description',
    'FORMS.RadioInput_Text_Furnishing' : 'Furnishing',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Furnishing',
    'FORMS.Input_Label_OrderType'   : 'Type',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Article return",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Lost",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Change Total",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Order",
    'GLOBAL.Button_Text_Logout' : 'Logout',
    'GLOBAL.Button_Text_Filter' : 'Filter',
    'GLOBAL.Button_Text_Sort' : 'Sort',
    'GLOBAL.Text_Version' : 'Version { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Cancel',
    'ATTENDANCE.Button_CheckIn': 'Check-In',
    'ATTENDANCE.Button_CheckOut': 'Check-Out',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Select an exhibition first.',
    'ATTENDANCE.Button_RetryScan': 'Scan again',
    'ATTENDANCE.Button_Close': 'Close',
    'ATTENDANCE.Modal_Title_CheckIn': 'Scan Check-In',
    'ATTENDANCE.Modal_Title_CheckOut': 'Scan Check-Out',
    'ATTENDANCE.Scanner_Hint': 'Point the camera at the QR code',
    'ATTENDANCE.Processing_Locating_Title': 'Refining your location…',
    'ATTENDANCE.Processing_Locating_Text': 'Please stay still. This may take up to 15 seconds.',
    'ATTENDANCE.Processing_Submitting_Title': 'Submitting scan...',
    'ATTENDANCE.Processing_Submitting_Text': 'Please wait. Saving attendance.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Location access required',
    'ATTENDANCE.Error_GpsPermission_Text': 'Allow location access in the browser and try again.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Weak GPS signal',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Coordinates were not found. Move closer to the exit and scan again.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS unavailable',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Location data is not available on this device.',
    'ATTENDANCE.Error_Camera_Title': 'Camera unavailable',
    'ATTENDANCE.Error_Camera_Text': 'Allow camera access and try again.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Camera access blocked',
    'ATTENDANCE.Error_CameraPermission_Text': 'Allow camera access in the browser site settings and try again.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'No camera found',
    'ATTENDANCE.Error_CameraNotFound_Text': 'This device does not expose an available camera to the browser.',
    'ATTENDANCE.Error_SecureContext_Title': 'HTTPS required',
    'ATTENDANCE.Error_SecureContext_Text': 'Camera and GPS work in mobile browsers only over HTTPS. Open the app through an HTTPS dev tunnel.',
    'ATTENDANCE.Error_Server_Title': 'Scan failed',
    'ATTENDANCE.Error_Server_Text': 'The server did not process the scan. Check your internet connection and try again.',
    'ATTENDANCE.Error_Generic_Title': 'Scan failed',
    'ATTENDANCE.Error_Generic_Text': 'Please try again.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Check-In successful',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Check-Out successful',
    'ATTENDANCE.Result_Accepted_Text': 'Time: { serverTime }. You are recorded in the system.',
    'ATTENDANCE.Result_Duplicate_Title': 'Already recorded',
    'ATTENDANCE.Result_Duplicate_Text': 'This scan has already been saved.',
    'ATTENDANCE.Result_OpenSessionElsewhere_Title': 'Checked in at another exhibition',
    'ATTENDANCE.Result_OpenSessionElsewhere_Text': 'Check out there before checking in here. If you cannot access that exhibition, contact your site or project management.',
    'ATTENDANCE.Result_ShiftClosed_Title': 'Shift already closed',
    'ATTENDANCE.Link_MyTimeRecords': 'View my time records',
    'ATTENDANCE.Result_ShiftClosed_Text': 'Your shift is already closed. If you did not check out, a manager may have closed it. To start a new shift, check in.',
    'ATTENDANCE.Result_AlreadyCheckedIn_Title': 'Already checked in',
    'ATTENDANCE.Result_AlreadyCheckedIn_Text': 'Check out of this exhibition before checking in again.',
    'ATTENDANCE.Result_Rejected_Title': 'Access rejected',
    'ATTENDANCE.Result_OutsideRadius_Text': 'You are too far from the entrance. Move closer to the entrance.',
    'ATTENDANCE.Result_InvalidQr_Text': 'This QR code is not valid for Check-In/Out.',
    'ATTENDANCE.Result_GenericRejected_Text': 'The scan was rejected.',
    'ATTENDANCE.Button_Back': 'Back',
    'ATTENDANCE.Button_TryAgain': 'Try again',
    'ATTENDANCE.Button_GotIt': 'Got it',
    'ATTENDANCE.Overview_NotCheckedIn': 'Not checked in',
    'ATTENDANCE.Overview_CheckInPrompt': 'Check in by{ br }scanning QR code',
    'ATTENDANCE.Overview_CheckedIn_Label': 'You’ve checked in',
    'ATTENDANCE.Overview_CheckedInAt': 'at { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Before starting work, scan the QR code to check in',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'To check out point at the QR code at the exhibition',
    'ATTENDANCE.Error_StatusLoad_Text': 'Could not load check-in status.',
    'ATTENDANCE.Error_CameraDesign_Title': 'The app can’t open your camera',
    'ATTENDANCE.Error_CameraDesign_Text': 'To check in you need to scan the code with your phone camera. Just tap Try again and allow the camera when your phone asks.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Still not working? You may have blocked the camera — check your browser’s permissions.',
    'ATTENDANCE.Error_LocationDesign_Title': 'The app can’t see your location',
    'ATTENDANCE.Error_LocationDesign_Text': 'Check-in needs your location to confirm you’re at the venue. Turn it on in your phone’s settings, then tap Try again.',
    'ATTENDANCE.Result_CheckedInAt': 'You checked in on { date } at { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'You have successfully checked in for work at { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'You finished work and{ br }checked out at { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'You must be at the venue',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Your location doesn’t match the exhibition. Check-ins are recorded with GPS, scan again when you are at the right place.',
    'ATTENDANCE.Result_LowAccuracy_Title': 'Low Location Accuracy',
    'ATTENDANCE.Result_LowAccuracy_Badge': 'Accuracy: { accuracy } (Too low)',
    'ATTENDANCE.Result_LowAccuracy_CheckIn': 'To check in, please:',
    'ATTENDANCE.Result_LowAccuracy_CheckOut': 'To check out, please:',
    'ATTENDANCE.Result_LowAccuracy_PreciseLocation': 'Enable "Precise Location" for your browser in phone settings',
    'ATTENDANCE.Result_LowAccuracy_Wifi': 'Turn on Wi-Fi to help locate your device',
    'ATTENDANCE.Result_LowAccuracy_Retry': 'Then tap { back } and scan the code again.',
    'ATTENDANCE.Accuracy_Meters': '{ value } m',
    'ATTENDANCE.Accuracy_Kilometers': '{ value } km',
    'ATTENDANCE.Result_InvalidQr_Title': 'That’s not the right code',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Check-in not possible',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Check-out not possible',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'This QR code does not belong to your event. Please contact your site or project management.',
    'ATTENDANCE.Result_OutdatedQr_Text': 'This QR code is out of date - please scan the newest QR Code.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Check-in not possible!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Another person has already been checked in with this phone. The app does not allow two different users to check in using the same device!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Check-in scan not possible!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Check-in is only available during the scheduled event period. Please contact your site or project management.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Check-out is not available now',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'This action is only available during the configured exhibition period. Check the selected exhibition and its dates.',
    'ATTENDANCE.TimeRecords_InProgress': 'in progress',
    'ATTENDANCE.TimeRecords_Missed': 'missed',
    'ATTENDANCE.TimeRecords_Empty': 'No time records yet.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Could not load time records.',
    'MENUS.Label_MyTimeRecords': 'My time records',
    'PAGE.Title_MyTimeRecords': 'My time records',
    'GLOBAL.Badge_Text_New' : 'NEW',
    'GLOBAL.Modal_Title_Filters' : 'Filters',
    'GLOBAL.Modal_Title_SortBy' : 'Sort by',
    'GLOBAL.TimeLeft' : '{ timeLeft } left',
    'GLOBAL.Text_Piece' : 'pcs.',
    'GLOBAL.Button_Text_Confirm' : 'Confirm',
    'GLOBAL.Language_Default' : 'Default',
    'TRANSLATION.Button_Text_Translate' : 'Translate',
    'TRANSLATION.Button_Text_TranslateInput' : 'Translate to German',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Translate to English',
    'TRANSLATION.Button_Text_TranslateNative' : 'Translate to my language',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Show original German',
    'TRANSLATION.Text_InputTranslating' : 'Translating...',
    'TRANSLATION.Text_InputTranslated' : 'Translated',
    'TRANSLATION.Text_InputTranslationError' : 'Translation failed',
    'TRANSLATION.Text_InputTranslationRequired' : 'Please translate the text before sending',
    'TRANSLATION.Text_ApiUnavailable' : 'Translation is not available right now',
    'GLOBAL.Card_Hero_Hall' : 'Hall',
    'GLOBAL.Card_Hero_Block' : 'Block',
    'GLOBAL.Card_Hero_Stand' : 'Stand',
    'GLOBAL.Comment': 'Comment',
    'HALL.Button_Text_HallPlan' : 'Hall plan',
    'HALL.Link_Text_HallPlan' : '{ hallName } hall plan',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hall',
    'JOB.Card_Hero_Number' : 'Job Nr.',
    'JOB.Card_Hero_Block' : 'Block',
    'JOB.Card_Hero_Stand' : 'Stand',
    'JOB.Card_Hero_Exhibitor' : 'Exhibitor',
    'JOB.Button_Text_ToTheStand' : 'To the stand',
    'JOB.Text_Creator' : 'by { whoCreate } on { whenCreate }',
    'JOB.Text_InWork' : 'by { whoWork } on { whenWork }',
    'JOB.Text_Executor' : 'by { whoExecute } on { whenExecute }',
    'JOB.Text_DurationTime' : 'Duration: { time }',
    'JOB.Type_Claim' : 'mp Claim',
    'JOB.Type_AllClaims' : 'Claim',
    'JOB.Type_CustomerClaim' : 'Exhibitor Claim',
    'JOB.Type_LastMinute' : 'Last minute',
    'JOB.Type_Damage' : 'Damage',
    'JOB.Type_ProtocolDefect' : 'Protocol defect',
    'JOB.Button_ChangeStatus_Waiting' : 'Take job',
    'JOB.Button_ChangeStatus_InProgress' : 'Job In progress',
    'JOB.Button_ChangeStatus_Done' : 'Finish Job',
    'JOB.Modal_Title_Photo' : 'Job photo',
    'JOB.Filter_Params_JobType' : 'Type: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Craft: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'New { jobType }',
    'JOB.Modal_Title_EditJob' : 'Edit { jobType }',
    'JOB.Button_Text_AddClaim' : 'Add mp claim job',
    'JOB.Button_Text_AddCustomerClaim' : 'Add exhibitor claim job',
    'JOB.Button_Text_AddLastMinute' : 'Add last minute Job',
    'JOB.Button_Text_AddDamage' : 'Add damage photo',
    'JOB.Button_Text_AddProtocolDefect' : 'Add protocol defect',
    'DAMAGE.Card_Title' : 'Damages of { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : '{ exhibitor } damages',
    'DAMAGE.Status_Label_New' : 'Unchecked',
    'DAMAGE.Status_Label_Check' : 'Checked',
    'DAMAGE.Status_Label_DCheck' : 'Approved',
    'DAMAGE.Button_Text_Stand' : 'Stand',
    'DAMAGE.Button_Text_Photo' : 'Photo',
    'DAMAGE.Button_Text_AddNote' : "ADD NOTE",
    'DAMAGE.Modal_Button_AddPhoto' : 'Add photo',
    'DAMAGE.Modal_Button_CreateReport' : 'Create report',
    'DAMAGE.Modal_Button_EditReport' : 'Edit report',
    'DAMAGE.AsCraft_label' : "Damages",
    "DAMAGE.Button_Text_Open" : "Open",
    "STAND.Block_Title_Damages" : "Damages",
    'MENUS.Label_Overview' : 'Overview',
    'MENUS.Label_Stands' : 'Stands',
    'MENUS.Label_Jobs' : 'Jobs',
    'MENUS.Label_ExpoPlan' : 'Expo Plan',
    'MENUS.Label_More' : 'More',
    'MENUS.Label_SelectExhibition' : 'Select exhibition',
    'MENUS.Label_CraftsOverview' : 'Crafts overview',
    'MENUS.Label_HallsOverview' : 'Halls overview',
    'MENUS.Label_ViewDamages' : 'View damages',
    'MENUS.Label_Downloads' : 'Downloads',
    'MENUS.Label_Documents' : 'Documents',
    'MENUS.Label_FurnishingLeftovers' : 'Furnishing leftovers',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Collect Graphics',
    'NO_DATA.Exhibitions' : 'You don\'t have any exhibitions yet.',
    'NO_DATA.Documents' : 'Current exhibition don\'t have { br } any documents yet.',
    'NO_DATA.Stands' : 'Stands matching the request { br } were not found',
    'NO_DATA.StandPhoto' : 'You don\'t have stand photo yet',
    'NO_DATA.DamagePhoto' : 'You don\'t have photo of damages { br } of this stand yet',
    'NO_DATA.Stand_NoKeys' : 'This stand don\'t have any keys yet',
    'NO_DATA.Stand_DoesNotExist' : 'This stand doesn\'t exist',
    'NO_DATA.Subcontractor_Unsigned' : 'Unsigned',
    'NO_DATA.Jobs' : 'Jobs matching the request { br } were not found',
    'NO_DATA.Damages' : 'Damages matching the request { br } were not found',
    'NO_DATA.Hall' : 'This hall doesn\'t exist',
    'NO_DATA.HallPlan' : 'We have not found a plan of this hall',
    'NO_DATA.Furnishing_Storage' : 'This Exhibition doesn\'t { br } have furnishing in storage',
    'NO_DATA.Furnishing_Orders' : 'This Exhibition doesn\'t { br } have furnishing orders',
    'PAGE.Title_Overview' : 'Overview',
    'PAGE.Title_ExhibitionSelection' : 'Exhibition selection',
    'PAGE.Title_Stands' : 'Stands',
    'PAGE.Title_Stand' : 'Stand',
    'PAGE.Title_StandComments' : 'Stand comments',
    'PAGE.Title_StandLog' : 'Stand Log',
    'PAGE.Title_StandKeys' : 'Stand Keys',
    'PAGE.Title_ViewDamages' : 'View Damages',
    'PAGE.Title_AdditionalMenu' : 'Additional menu',
    'PAGE.Title_Jobs' : 'Jobs',
    'PAGE.Title_ExpoPlan' : 'Expo Plan',
    'PAGE.Title_Documents' : 'Documents',
    'PAGE.Title_FurnishingLeftovers' : 'LM Furnishing',
    'PAGE.Title_FurnishingReturns' : 'Furnishing Change log',
    'PAGE.Title_HallPlan' : 'Hall Plan',
    'PAGE.Title_HallsOverview' : 'Halls overview',
    'PAGE.Title_CraftsOverview' : 'Crafts overview',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Collect Graphics',
    'SORT.Text_NewestByCreation' : 'Newest by creation date',
    'SORT.Text_OldestByCreation' : 'Oldest by creation date',
    'SORT.Text_ExhibitorNameAZ' : 'Exhibitor name (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Exhibitor name (Z-A)',
    'SORT.Text_FinishedFirst' : 'Finished first',
    'SORT.Text_InProgressFirst' : 'Open first',
    'SORT.Text_StandNumberAZ' : 'Stand number (A-Z)',
    'SORT.Text_StandNumberZA' : 'Stand number (Z-A)',
    'SORT.Text_CorridorAZ' : 'Corridor (A-Z)',
    'SORT.Text_CorridorZA' : 'Corridor (Z-A)',
    'SORT.Text_BlockAZ' : 'Block (A-Z)',
    'SORT.Text_BlockZA' : 'Block (Z-A)',
    'SORT.Text_FlagFirst' : 'With flag first',
    'SORT.Text_FlagLast' : 'With flag last',
    'SORT.Text_HallAZ' : 'Hall (A-Z)',
    'SORT.Text_HallZA' : 'Hall (Z-A)',
    'SORT.Text_StatusAZ' : 'Approved',
    'SORT.Text_StatusZA' : 'Unchecked',
    'STAND.Modal_Title_Search' : 'Search',
    'STAND.Input_Placeholder_Search' : 'Search',
    'STAND.Filter_Params_Exhibitor' : 'Exhibitor: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'With comments',
    'STAND.Card_Hero_Hall' : 'Hall',
    'STAND.Card_Hero_Block' : 'Block',
    'STAND.Card_Hero_Stand' : 'Stand',
    'STAND.Card_Hero_DeliveryTime' : 'Delivery time',
    'STAND.Modal_Title_StandPlan' : 'Stand Drawing',
    'STAND.Modal_Button_StandPlan' : 'Drawing',
    'STAND.Card_Button_Details' : 'Details { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Stand Photo',
    'STAND.Modal_Button_StandPhoto' : 'Photo',
    'STAND.Modal_Button_SavePhoto' : 'Save photo',
    'STAND.Modal_Button_AddPhoto' : 'Add photo',
    'STAND.Button_Text_Comments' : 'Comments',
    'STAND.Button_Text_AddComment' : 'Add comment',
    'STAND.Modal_Title_AddComment' : 'Add comment',
    'STAND.Modal_Title_EditComment' : 'Edit comment',
    'STAND.Modal_Button_AddComment' : 'Add',
    'STAND.Modal_Button_SaveComment' : 'Save',
    'STAND.Text_NoComments' : 'There are no comments yet',
    'STAND.Text_AddFile' : 'Add file',
    'COMMENTS.Text_Uploading' : 'Uploading...',
    'STAND.Text_EditComment' : 'Edit',
    'STAND.Text_DeleteComment' : 'Delete',
    'STAND.Text_CommentDraftError' : 'Draft comment is not ready yet',
    'STAND.Block_Title_Overview' : 'Overview',
    'STAND.Block_Title_Materials' : 'Additional information',
    'STAND.Block_Title_Crafts' : 'Crafts',
    'STAND.Block_ItemTitle_Hall' : 'Hall',
    'STAND.Block_ItemTitle_Block' : 'Block',
    'STAND.Block_ItemTitle_Stand' : 'Stand',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Proauf number',
    'STAND.Block_ItemTitle_Jobs' : 'Jobs',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } in progress',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } open',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } finished',
    'STAND.Block_Button_ViewStandJobs' : 'View stand jobs',
    'STAND.Modal_Title_StandGraphic' : 'Stand Graphic',
    'STAND.Modal_Button_StandGraphic' : 'Stand Graphic',
    'STAND.Modal_Title_ExtraInfo' : 'Extra Info',
    'STAND.Modal_Button_ExtraInfo' : 'Extra Info',
    'STAND.Button_Text_ViewKeys' : 'View keys',
    'STAND.Button_Text_ViewLogs' : 'View logs',
    'STAND.Modal_Button_AddKey' : 'Add Key',
    'STAND.Modal_Title_AddKey' : 'Add Key',
    'STAND.Modal_Title_EditKey' : 'Edit key',
    'STAND.Modal_Button_UpdateKey' : 'Update key',
    'STAND.Filter_Params_Stand' : 'Stand { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Delete',
    'STAND.Text_ModalDelete_Question' : 'Are you sure you want to delete the { keyName } key?',
    'STAND.External_Exhibition' : 'Exhibition you are not assigned to',
    'JOB.Button_Text_ViewPhoto' : 'View Photo',
    'OVERVIEW_TYPES.Label_InTotal' : 'in total',
    'OVERVIEW_TYPES.Label_Finished' : 'finished',
    'OVERVIEW_TYPES.Label_Open' : 'open',
    'OVERVIEW_TYPES.Label_Claims' : 'claims',
    'OVERVIEW_TYPES.Label_LastMinute' : 'last min',
    'OVERVIEW_TYPES.Label_Overdue' : 'overdue',
    'FURNISHING.TabName_Storage' : 'Storage',
    'FURNISHING.TabName_Refund' : 'Returns',
    'FURNISHING.TabName_OrderLog' : 'Order log',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'LM Equipment Quantities',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Furnishing in the store',
    'FURNISHING.Button_Text_Return' : 'Return',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Choose furnishing',
    'FURNISHING.Modal_Title_Photo' : "Furnishing photo",
    'FURNISHING.Order_Type_Refund' : "Return",
    'FURNISHING.Order_Type_Lost' : "Lost",
    'FURNISHING.Order_Type_Correction' : "Correction",
    'FURNISHING.Order_Type_Order' : "Order",
};

export default english;
